import './styles.css';

angular.module('shared-components.extended-filters').component('gccsExtendedListFilterTags', {
  controller: 'ExtendedListFilterTagsController',
  template: require('./template.html'),
  bindings: {
    service: '<'
  }
});
